
export const SET_HAS_SYSTEM_ERROR = 'SET_HAS_SYSTEM_ERROR';

export const SET_PLAYING_VIDEO = 'SET_PLAYING_VIDEO';


